import type { SeoResolver } from '../types';

/** SEO for a selected veterinary facility. Moved verbatim from SEO.tsx. */
export const veterinarySeoResolver: SeoResolver = (ctx) => {
  const vet = ctx.selections.veterinaryFacility;
  if (!vet) return null;

  const { siteName } = ctx;
  const p = vet.properties;
  const vName = p.village_na || 'Veterinary Center';
  const vTal = p.taluk_name || '';

  return {
    title: `${vName} Veterinary Clinic ${vTal ? `(${vTal})` : ''} | ${siteName}`,
    description: `Find accurate directions, coordinates, and proximity maps for the ${vName} veterinary facility${vTal ? ` located in ${vTal} Taluk` : ''}.`,
    breadcrumbLabel: p.village_na || ''
  };
};
